import {CONFIG} from '../../appConfig';

export default {
  /**
   * @desc Get CDA session object
   * @param {Object} data {params}
   * @returns {Object}
   * @memberof services.cda.session
   * @example
   * services.cda.session.current();
   * // dispatched results stored in `state.gmi.cda.session.current`
   */
  current(data = {}) {
    const {params = {}} = data;
    return {
      method: 'GET',
      origin: CONFIG.CDA_ORIGIN_URL,
      endpoint: `session/current`,
      params
    };
  }
};
